export enum RosterUploadStep {
  DOWNLOAD_TEMPLATE,
  UPLOAD_CSV,
  CONFIRMATION,
}

export const RosterUploadStepLabels: Record<RosterUploadStep, string> = {
  [RosterUploadStep.DOWNLOAD_TEMPLATE]: 'Template',
  [RosterUploadStep.UPLOAD_CSV]: 'Upload',
  [RosterUploadStep.CONFIRMATION]: 'Confirmation',
};

export const RosterUploadSteps: RosterUploadStep[] = [
  RosterUploadStep.DOWNLOAD_TEMPLATE,
  RosterUploadStep.UPLOAD_CSV,
  RosterUploadStep.CONFIRMATION,
];

export enum TransactionStatus {
  UPLOADED = 'uploaded',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  SYNCED = 'synced',
  FAILED = 'failed',
  SUPERSEDED = 'superseded',
  REJECTED = 'rejected',
}

export const statusColors: Record<TransactionStatus, string> = {
  [TransactionStatus.SYNCED]: 'bg-green-100 text-green-600',
  [TransactionStatus.PROCESSING]: 'bg-yellow-100 text-yellow-600',
  [TransactionStatus.PROCESSED]: 'bg-yellow-100 text-yellow-600',
  [TransactionStatus.UPLOADED]: 'bg-blue-100 text-blue-600',
  [TransactionStatus.FAILED]: 'bg-red-100 text-red-600',
  [TransactionStatus.SUPERSEDED]: 'bg-red-100 text-red-600',
  [TransactionStatus.REJECTED]: 'bg-red-100 text-red-600',
};

export const transactionLabels: Record<TransactionStatus, string> = {
  [TransactionStatus.SYNCED]: 'Synced',
  [TransactionStatus.PROCESSING]: 'Processing',
  [TransactionStatus.PROCESSED]: 'In review',
  [TransactionStatus.UPLOADED]: 'Uploaded',
  [TransactionStatus.FAILED]: 'Failed',
  [TransactionStatus.SUPERSEDED]: 'Superseded',
  [TransactionStatus.REJECTED]: 'Rejected',
};
